var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.TableWithFrontPaginationDesign,{staticClass:"offers-goals__table mt-0",attrs:{"title":"","items":_setup.getItems,"headers":_setup.headers,"unique-data":_setup.uniqueData,"loading":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }